module.exports = __webpack_public_path__ + "img/sh_ig.0752caca.svg";